/**
 * The pool screen's per-type registry (ISSUE-1334). Survivor keeps the panes
 * the screen has always mounted. Every other pool type brings its own Game
 * tab, Results tab and Settings section from its own feature folder, so the
 * type builders never edit the pool screen itself.
 */
import type { ReactNode } from "react";

import { PickemGameTab } from "../pickem/PickemGameTab";
import { PickemResultsTab } from "../pickem/PickemResultsTab";
import { PickemSettingsSection } from "../pickem/PickemSettingsSection";
import { SquaresGameTab } from "../squares/SquaresGameTab";
import { SquaresResultsTab } from "../squares/SquaresResultsTab";
import { SquaresSettingsSection } from "../squares/SquaresSettingsSection";
import { StripCardGameTab } from "../strips/StripCardGameTab";
import { StripCardResultsTab } from "../strips/StripCardResultsTab";
import { StripCardSettingsSection } from "../strips/StripCardSettingsSection";
import type { typePoolTypePaneProps } from "./poolTypePaneProps";

export type typePoolTypePanes = {
  GameTab: (props: typePoolTypePaneProps) => ReactNode;
  ResultsTab: (props: typePoolTypePaneProps) => ReactNode;
  /** Rendered at the top of the Settings tab, above Chat and Notifications. */
  SettingsSection: (props: typePoolTypePaneProps) => ReactNode;
};

const POOL_TYPE_PANES: Readonly<Record<string, typePoolTypePanes>> = {
  squares: {
    GameTab: SquaresGameTab,
    ResultsTab: SquaresResultsTab,
    SettingsSection: SquaresSettingsSection,
  },
  stripCard: {
    GameTab: StripCardGameTab,
    ResultsTab: StripCardResultsTab,
    SettingsSection: StripCardSettingsSection,
  },
  pickem: {
    GameTab: PickemGameTab,
    ResultsTab: PickemResultsTab,
    SettingsSection: PickemSettingsSection,
  },
};

/** The type's own panes, or null for Survivor (and while the type is unknown). */
export function poolTypePanes(
  contestType: string | null,
): typePoolTypePanes | null {
  if (contestType === null) return null;
  return POOL_TYPE_PANES[contestType] ?? null;
}
